module.exports = __webpack_public_path__ + "img/logo.2397052a.png";